import { render, staticRenderFns } from "./EditExtraLiftDialog.vue?vue&type=template&id=3b838438&"
import script from "./EditExtraLiftDialog.vue?vue&type=script&lang=js&"
export * from "./EditExtraLiftDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports